import { render, staticRenderFns } from "./DeletedFormatSelector.vue?vue&type=template&id=6727127b&scoped=true&"
import script from "./DeletedFormatSelector.vue?vue&type=script&lang=ts&"
export * from "./DeletedFormatSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DeletedFormatSelector.vue?vue&type=style&index=0&id=6727127b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6727127b",
  null
  
)

export default component.exports